import RoleGuard from "@/pages/role-guard";
import RoleDetails from "@/pages/roles/details";
import NewRole from "@/pages/roles/new";
import { createRoleDetailsBreadcrumb } from "@/queries/roles";
import { Permissions } from "@/utils/permissions";
import type { QueryClient } from "@tanstack/react-query";
import { lazy } from "react";
import {
  makeHandle,
  makeOptionalNameHandle,
  withNotFoundRedirect,
  type LoaderParams,
} from "./router.helpers";

const Roles = lazy(() => import("@/pages/roles"));

export const createRolesRoutes = (queryClient: QueryClient) => ({
  path: "roles",
  children: [
    {
      index: true,
      element: (
        <RoleGuard permissions={[Permissions.roles.read]}>
          <Roles />
        </RoleGuard>
      ),
      handle: makeHandle({ label: "Roles" }),
    },
    {
      path: "new",
      element: (
        <RoleGuard
          permissions={[
            Permissions.roles.create,
            Permissions.roles.read,
            Permissions.roles["assign-permissions"],
          ]}
        >
          <NewRole />
        </RoleGuard>
      ),
      handle: makeHandle(
        { label: "Roles", path: "/roles" },
        { label: "Crear rol" },
      ),
    },
    {
      path: ":id",
      element: (
        <RoleGuard
          permissions={[Permissions.roles.update, Permissions.roles.read]}
        >
          <RoleDetails />
        </RoleGuard>
      ),
      loader: ({ params }: LoaderParams) =>
        withNotFoundRedirect(
          () => createRoleDetailsBreadcrumb(queryClient, params.id || "")(),
          "/roles",
        ),
      handle: makeOptionalNameHandle({ label: "Roles", path: "/roles" }),
    },
  ],
});
